import { prepareDateToApi } from '../utils/date-api-helper';

export async function fetchPosts(date) {
    const { fromDate, toDate } = prepareDateToApi(date);
    const url = `${window.BASE_URL}rest/V1/calendar/events?from=${fromDate.year}-${fromDate.month}-${fromDate.date}&to=${toDate.year}-${toDate.month}-${toDate.date}`;
    const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const data = await response.json();

    return data.items;
}
